import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showToast } from '../../store/slices/formconfig';
import './style.css'; // You'll create this CSS file

interface Props {
  show: boolean;
  onClose: () => void;
  onSubmit: (deliveryCode: string) => void;
}

const DeliveryCodeModal: React.FC<Props> = ({ show, onClose, onSubmit }) => {
  const dispatch = useDispatch();
  const [codes, setCodes] = useState(['', '', '', '']);
  const inputRefs = [
    React.useRef<HTMLInputElement>(null),
    React.useRef<HTMLInputElement>(null),
    React.useRef<HTMLInputElement>(null),
    React.useRef<HTMLInputElement>(null)
  ];

  if (!show) {
    return null;
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 1) {
      const newCodes = [...codes];
      newCodes[index] = value;
      setCodes(newCodes);

      if (value.length === 1 && index < 3) {
        inputRefs[index + 1].current?.focus();
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === 'Backspace' && codes[index] === '' && index > 0) {
      inputRefs[index - 1].current?.focus();
    }
  };

  const handleSubmit = () => {
    const deliveryCode = codes.join('');
    if (deliveryCode.length === 4) {
      onSubmit(deliveryCode);
    } else {
      dispatch(showToast({ message: 'Please enter a 4-digit delivery code.', type: 'error' }));
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container" style={{width: 300}}>
        <div className="modal-header">
          <h3>Enter 4 digit delivery code</h3>
          <span className="close-button" onClick={onClose}>&times;</span>
        </div>
        <div className="modal-body">
          <div className="code-inputs">
            {codes.map((code, index) => (
              <input
                key={index}
                ref={inputRefs[index]}
                type="number"
                inputMode="numeric"
                maxLength={1}
                value={code}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                className="code-input"
              />
            ))}
          </div>
        </div>
        <div className="modal-footer">
          <button className="submit-button" onClick={handleSubmit}>Submit</button>
        </div>
      </div>
    </div>
  );
};

export default DeliveryCodeModal;